import { useTranslation } from "react-i18next";

type LanguageSelectProps = {
  languages: string[];
  value: string;
  onChange: (language: string) => void;
  className?: string;
};

export default function LanguageSelect({ languages, value, onChange, className = "" }: LanguageSelectProps) {
  const { i18n } = useTranslation("common");

  return (
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={`px-2 py-1 text-xs rounded-lg border border-gray-200 bg-white text-gray-700 ${className}`}
    >
      {languages.map((lng) => {
        const label = i18n.getFixedT(lng)("languageName", { defaultValue: lng });
        return (
          <option key={lng} value={lng}>
            {label}
          </option>
        );
      })}
    </select>
  );
}
